import { render, staticRenderFns } from "./ContactVerification.vue?vue&type=template&id=39c6db9d"
import script from "./ContactVerification.vue?vue&type=script&lang=js"
export * from "./ContactVerification.vue?vue&type=script&lang=js"
import style0 from "./ContactVerification.vue?vue&type=style&index=0&id=39c6db9d&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39c6db9d')) {
      api.createRecord('39c6db9d', component.options)
    } else {
      api.reload('39c6db9d', component.options)
    }
    module.hot.accept("./ContactVerification.vue?vue&type=template&id=39c6db9d", function () {
      api.rerender('39c6db9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/steps/ContactVerification/ContactVerification.vue"
export default component.exports